import { Controller } from "@hotwired/stimulus"

// Handles live background color/image preview in My Account settings.
// Writes to localStorage for instant persistence + updates hidden fields for DB save.
export default class extends Controller {
  static targets = ["option", "thumbnail", "check", "colorField", "imageField"]

  preview(event) {
    const raw = event.target.value          // "none", "color:sage", "image:moon"
    const [type, key] = raw.includes(":") ? raw.split(":") : [raw, ""]

    // Find the selected option wrapper
    const selectedOption = this.optionTargets.find(o => {
      if (type === "none") return o.dataset.type === "none"
      return o.dataset.value === key && o.dataset.type === type
    })

    const hex     = selectedOption?.dataset.hex || ""
    const darkHex = selectedOption?.dataset.darkHex || ""
    const imgUrl  = selectedOption?.dataset.imageUrl || ""

    // Update hidden fields — mutual exclusivity
    if (this.hasColorFieldTarget && this.hasImageFieldTarget) {
      if (type === "color") {
        this.colorFieldTarget.value = key
        this.imageFieldTarget.value = ""
      } else if (type === "image") {
        this.colorFieldTarget.value = ""
        this.imageFieldTarget.value = key
      } else {
        this.colorFieldTarget.value = ""
        this.imageFieldTarget.value = ""
      }
    }

    // Write to localStorage immediately so it survives Turbo navigation
    if (type === "color" && hex) {
      localStorage.setItem("mod-bg-type", "color")
      localStorage.setItem("mod-bg-color", hex)
      localStorage.setItem("mod-bg-color-dark", darkHex || hex)
      localStorage.removeItem("mod-bg-image")
    } else if (type === "image" && imgUrl) {
      localStorage.setItem("mod-bg-type", "image")
      localStorage.setItem("mod-bg-image", imgUrl)
      localStorage.removeItem("mod-bg-color")
      localStorage.removeItem("mod-bg-color-dark")
    } else {
      localStorage.removeItem("mod-bg-type")
      localStorage.removeItem("mod-bg-color")
      localStorage.removeItem("mod-bg-color-dark")
      localStorage.removeItem("mod-bg-image")
    }

    // Live preview
    this.applyBackground(type, key, hex, darkHex, imgUrl)

    // Update visual selection state on ALL thumbnails (across both grids)
    this.optionTargets.forEach((option) => {
      const oType  = option.dataset.type
      const oValue = option.dataset.value
      const thumb  = option.querySelector("[data-background-picker-target='thumbnail']")
      const check  = option.querySelector("[data-background-picker-target='check']")

      let isSelected = false
      if (type === "none" && oType === "none") isSelected = true
      else if (type === oType && key === oValue) isSelected = true

      if (thumb) {
        if (isSelected) {
          thumb.classList.remove("border-transparent", "hover:border-mod-charcoal/30", "dark:hover:border-white/30")
          thumb.classList.add("border-mod-charcoal", "dark:border-white")
        } else {
          thumb.classList.remove("border-mod-charcoal", "dark:border-white")
          thumb.classList.add("border-transparent", "hover:border-mod-charcoal/30", "dark:hover:border-white/30")
        }
      }

      if (check) {
        check.style.display = isSelected ? "" : "none"
      }
    })
  }

  applyBackground(type, key, hex, darkHex, imageUrl) {
    const html = document.documentElement
    if (type === "image" && imageUrl) {
      html.style.background = `url(${imageUrl}) center/cover fixed no-repeat`
      html.classList.add("has-bg")
    } else if (type === "color" && key && hex) {
      const isDark = html.classList.contains("dark")
      html.style.background = isDark ? (darkHex || hex) : hex
      html.classList.add("has-bg")
    } else {
      html.classList.remove("has-bg")
      const isDark = html.classList.contains("dark")
      html.style.background = isDark ? "#1a1714" : "#f5f2ed"
    }
  }
}
